<template>
  <div>
    <b-row v-if="!modalPopup">
      <b-col class="col-12 col-sm-12 text-center text-sm-left p-0 pt-0 pt-sm-1 pt-md-2 pt-lg-3">
        <b-img
            :src=logoUrl alt="logo" class="imgLogo"></b-img>
        <div class="titleBx" style="padding-top: 20px;float: left;margin-left: 10px;">
          <span class="customTitle" style="bottom:0px;">Provider Directory Search</span>
        </div>
      </b-col>
    </b-row>
    <hr v-if="!modalPopup"/>
    <div class="col-12 p-0">
      <div class="col-12 p-0 text-right mb-2">
        <b-row >
          <b-col class="text-right">
            <!--            <b-form-select-->
            <!--                id="input-1"-->
            <!--                class="col-3 mr-2"-->
            <!--                v-model="selectedReport"-->
            <!--                :options="provReportList"-->
            <!--                v-if="provReportList.length > 0"-->
            <!--                size="sm"-->
            <!--                :style="cusFontSizeSelect"-->
            <!--                @input="setReport(selectedReport)"-->
            <!--            ></b-form-select>-->
            <b-button class="btn-sm" variant="info" @click="decreaseFontSize()" :disabled="fontSize==12">A<sup>-</sup>
            </b-button>
            <b-button class="btn-sm ml-1" variant="info" @click="increaseFontSize()" :disabled="fontSize==18"
                      href="javascript:;">A<sup>+</sup></b-button>
            <b-button class="btn-sm ml-3" variant="info" v-if="showDownloadBtn" :href="downloadUrl" target="_blank">
              Download Provider Directory
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col class="col-12 col-sm-6">
          <b-form @submit.prevent="searchProvider" novalidate>
            <b-card class="border border-info">
              <b-card-title class="text-left ml-3">
                Provider Search
              </b-card-title>
              <div class="float-left h-25 col-12 text-left tagBox"
                   v-if="form.provData.specialty.length>0 || form.provData.language.length>0 || form.provData.gender.length>0 || form.provData.state.length>0 || form.provData.county.length>0">
                  <span :style="cusFontSize"
                        class="filterText">Selected Filter:</span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(each,i) in form.provData.specialty"
                      :key="each.value"
                >
                  {{ getProvSpecialty(each) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.provData.specialty)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(lang,i) in form.provData.language"
                      :key="lang.value"
                >
                  {{ getLangName(lang) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.provData.language)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>

                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(gend,i) in form.provData.gender"
                      :key="i"
                >
                    <span v-if="gend=='M'">Gender: Male</span>
                    <span v-if="gend=='F'">Gender: Female</span>
                    <span :style="cusFontSize"
                          aria-hidden="true"
                          class="text-dark align-top closeTags"
                          @click="removeThis(i,form.provData.gender)"
                    >
                      <sup :style="cusFontSize">
                        <i class="far fa-times-circle"></i>
                      </sup>
                    </span>
                  </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(ipa,i) in form.provData.ipa"
                      :key="ipa.value"
                >
                  {{ getFacilityTypeName(ipa) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.provData.ipa)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(st,i) in form.provData.state"
                      :key="st.value"
                >
                  {{ getStateName(st) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.provData.state)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(ct,i) in form.provData.county"
                      :key="ct.value"
                >
                  {{ ct }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.provData.county, 'prov')"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
              </div>
              <b-row>
                <b-col class="col-12">
                  <b-form-group
                      class="col-12 text-center"
                      id="input-group-6"
                      :style="cusFontSizeSelect"
                  >
                    <b-row>
                      <b-col class="col-12 col-sm-6 pr-0">
                        <b-form-input
                            v-model="form.provData.ProviderFirstName"
                            id="input-2"
                            required
                            size="lg"
                            placeholder="First Name"
                            :style="cusFontSize"
                        ></b-form-input>
                      </b-col>
                      <b-col class="col-12 col-sm-6 pr-0">
                        <b-form-input
                            v-model="form.provData.ProviderLastName"
                            id="input-2"
                            required
                            size="lg"
                            placeholder="Last Name"
                            :style="cusFontSize"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12">
                  <b-form-group
                      class="col-8 col-sm-7 col-lg-8 float-left pr-3 text-center"
                      id="input-group-9"
                      :style="cusFontSizeSelect"
                  >
                    <b-row>
                      <b-col class="col-12 col-sm-12 col-lg-12 pr-0">
                        <b-form-input
                            v-model="form.provData.addressName"
                            id="input-2"
                            required
                            size="lg"
                            placeholder="Group/Clinic Name"
                            :style="cusFontSize"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('specialty','prov')">
                    <a @click="toggleShow('specialty','prov')"
                       class="anchor btn btn-info col-12 text-light p-1 justify-content-start"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">Specialty</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showSpecialtyMenuProv" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="specialtyInputProv"
                          class="m-0 pr-1"
                          size="sm"
                          @keyup="searchSpec(specialtyInputProv,'prov')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.provData.specialty"
                          :options="specialtyFilterProv"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                  <!-- <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('ipa','prov')">
                    <a @click="toggleShow('ipa','prov')"
                       class="anchor btn btn-info col-12 text-light p-1 justify-content-start"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">IPA</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showIPAMenuProv" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="ipaInputProv"
                          class="m-0"
                          size="sm"
                          @keyup="searchIPA(ipaInputProv,'prov')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.provData.ipa"
                          :options="ipaFilterProv"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>-->
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12">
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('gender')">
                    <a @click="toggleShow('gender')" class="anchor btn btn-info col-12 text-light p-1 justify-content-start" :style="cusFontSizeSelect">
                      <div class="float-left text-white">Gender</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showGenderMenu" class="menu" :style="cusFontSizeSelect">
                      <b-form-checkbox-group
                          v-model="form.provData.gender"
                          :options="[{text:'Female',value:'F'},{text:'Male',value:'M'}
                                                ,{text:'Unknown',value:'U'},
                                                ]"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                      ></b-form-checkbox-group>
                    </div>

                  </b-col>
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('state','prov')">
                    <a @click="toggleShow('state','prov')"
                       class="anchor btn btn-info col-12 text-light p-1 justify-content-start"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">State</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showStateMenuProv" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="stateInputProv"
                          class="m-0"
                          size="sm"
                          @keyup="searchState(stateInputProv,'prov')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.provData.state"
                          :options="stateFilterProv"
                          value-field="State"
                          text-field="StateName"
                          name="flavour-2a"
                          button-variant="success"
                          @input="setCounty($event,'prov'); checkForReport(form.provData)"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('county','prov')">
                    <a @click="toggleShow('county','prov')"
                       :class="(disableProvCounty?'anchor_grey':'anchor') +' btn btn-info col-12 text-light p-1 justify-content-start'"
                       :style="cusFontSizeSelect" >
                      <div class="float-left text-white">County</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showCountyMenuProv" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="countyInputProv"
                          class="m-0"
                          size="sm"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.provData.county"
                          :options="getCountyList('prov',countyInputProv)"
                          value-field="County"
                          text-field="County"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                          :disabled="disableProvCounty"
                          @input="checkForReport(form.provData)"
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 mt-3">
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('language','prov')">
                    <a @click="toggleShow('language','prov')"
                       class="anchor btn btn-info col-12 text-light p-1 justify-content-start"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">Language</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showLanguageMenuProv" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="languageInputProv"
                          class="m-0"
                          size="sm"
                          @keyup="searchLang(languageInputProv,'prov')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.provData.language"
                          :options="languageFilterProv"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                  <b-col class="col-6 col-sm-7 col-lg-8 float-left pr-0">
                    <b-form-group
                        class="col-12 pl-0"
                        id="input-group-2"
                        :style="cusFontSizeSelect"
                    >
                      <b-form-input
                          id="input-2"
                          placeholder="Distance (Zip Code)"
                          v-model="form.provData.zipCode"
                          size="lg"
                          class="zipCodeInput"
                          :style="cusFontSizeSelect"
                          @change="checkForReport(form.provData)"
                      ></b-form-input>
                      <b-form-select
                          id="input-1"
                          v-model="form.provData.zipMiles"
                          v-if="form.provData.zipCode"
                          :options="milesData"
                          ref="zipMiles"
                          size="lg"
                          class="zipMilesSelect ml-3"
                          :style="cusFontSizeSelect"
                      ></b-form-select>
                      <b-form-checkbox
                          id="checkbox-1"
                          v-model="form.provData.PCPOnly"
                          name="checkbox-1"
                          value=1
                          unchecked-value=0
                          class="zipMilesSelect ml-1 mt-1"
                          style="font-size: 14px !important"
                      >
                        <b>PCP Only</b>
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12">
                  <b-button
                      type="submit"
                      @click="form.FacilitySearch = 0"
                      class="col-6 col-sm-4 col-md-3 btn btn-info btn-sm float-left ml-3"
                      :style="cusFontSizeSelect"
                      :disabled="loading"
                  >Search
                  </b-button>&nbsp;
                  <b-button
                      class="col-5 ml-2 col-sm-3 btn btn-secondary btn-sm float-left"
                      @click="clearAll('prov')"
                      :style="cusFontSizeSelect"
                      :disabled="loading"
                  >Clear
                  </b-button>
                  <div class="clearfix"></div>
                  <br>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </b-col>
        <b-col class="col-12 col-sm-6">
          <b-form @submit.prevent="searchProvider" novalidate>
            <b-card class="border border-info">
              <b-card-title class="text-left ml-3">
                Hospital/Ancillary Search
              </b-card-title>
              <div class="float-left h-25 col-12 text-left tagBox"
                   v-if="form.hospData.specialty.length>0 || form.hospData.facilityType.length>0 || form.hospData.county.length>0 || form.hospData.state.length>0">
                  <span :style="cusFontSize"
                        class="filterText">Selected Filter:</span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(each,i) in form.hospData.specialty"
                      :key="each.value"
                >
                  {{ getHospSpecialty(each) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.hospData.specialty)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(ft,i) in form.hospData.facilityType"
                      :key="ft.value"
                >
                  {{ getFacilityTypeName(ft) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.hospData.facilityType)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(st,i) in form.hospData.state"
                      :key="st.value"
                >
                  {{ getStateName(st) }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.hospData.state, 'prov')"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
                <span :style="cusFontSize"
                      type="button"
                      class="selTags m-2 p-0"
                      aria-label="Close"
                      v-for="(ct,i) in form.hospData.county"
                      :key="ct.value"
                >
                  {{ ct }}
                  <span :style="cusFontSize"
                        aria-hidden="true"
                        class="text-dark align-top closeTags"
                        @click="removeThis(i,form.hospData.county)"
                  >
                    <sup :style="cusFontSize">
                      <i class="far fa-times-circle"></i>
                    </sup>
                  </span>
                </span>
              </div>
              <b-row>
                <b-col class="col-12">
                  <b-form-group
                      class="mb-2 col-12 text-center pr-0"
                      id="input-group-5"
                      :style="cusFontSizeSelect"
                  >
                    <b-form-input
                        v-model="form.hospData.hospital"
                        id="input-2"
                        required
                        size="lg"
                        placeholder="Hospital/Ancillary or Facility Name"
                        :style="cusFontSize"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 mt-2">
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('specialty','hosp')">
                    <a @click="toggleShow('specialty','hosp')" class="anchor btn btn-info col-12 text-light p-1"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">Specialty</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showSpecialtyMenuHosp" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="specialtyInputHosp"
                          class="m-0"
                          size="sm"
                          @keyup="searchSpec(specialtyInputHosp,'hosp')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.hospData.specialty"
                          :options="specialtyFilterHosp"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('facilityType','hosp')">
                    <a @click="toggleShow('facilityType','hosp')"
                       class="anchor btn btn-info col-12 text-light p-1 justify-content-start"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">Facility Type</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showFTMenuHosp" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="facilityTypeInputHosp"
                          class="m-0"
                          size="sm"
                          @keyup="searchIPA(facilityTypeInputHosp,'hosp')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.hospData.facilityType"
                          :options="facilityTypeFilterHosp"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                </b-col>

              </b-row>
              <b-row>
                <b-col class="col-12 mt-3">
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('state','hosp')">
                    <a @click="toggleShow('state','hosp')"
                       class="anchor btn btn-info col-12 text-light p-1 justify-content-start"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">State</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showStateMenuHosp" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="stateInputHosp"
                          class="m-0"
                          size="sm"
                          @keyup="searchState(stateInputHosp,'hosp')"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.hospData.state"
                          :options="stateFilterHosp"
                          value-field="State"
                          text-field="StateName"
                          name="flavour-2a"
                          button-variant="success"
                          @input="setCounty($event,'hosp'); checkForReport(form.hospData)"
                          stacked
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                  <b-col class="col-6 col-sm-5 col-lg-4 float-left pr-0" @mouseleave="mouseOut('county','hosp')">
                    <a @click="toggleShow('county','hosp')"
                       :class="(disableHospCounty?'anchor_grey':'anchor') +' btn btn-info col-12 text-light p-1 justify-content-start'"
                       :style="cusFontSizeSelect">
                      <div class="float-left text-white">County</div>
                      <div class="arrowDownIcon float-right text-white"></div>
                    </a>
                    <div v-if="showCountyMenuHosp" class="menu pt-1" :style="cusFontSizeSelect">
                      <b-form-input
                          v-model="countyInputHosp"
                          class="m-0"
                          size="sm"
                          placeholder="Type to search"
                      ></b-form-input>
                      <b-form-checkbox-group
                          v-model="form.hospData.county"
                          :options="getCountyList('hosp',countyInputHosp)"
                          value-field="County"
                          text-field="County"
                          name="flavour-2a"
                          button-variant="success"
                          stacked
                          :disabled="disableHospCounty"
                          @input="checkForReport(form.hospData)"
                      ></b-form-checkbox-group>
                    </div>
                  </b-col>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 mt-3">
                  <b-form-group
                      class="col-12"
                      id="input-group-1"
                      :style="cusFontSizeSelect"
                  >
                    <b-form-input
                        id="input-2"
                        placeholder="Distance (Zip Code)"
                        v-model="form.hospData.zipCode"
                        size="lg"
                        class="zipCodeInput"
                        :style="cusFontSizeSelect"
                        @change="checkForReport(form.hospData)"
                    ></b-form-input>
                    <b-form-select
                        id="input-1"
                        v-model="form.hospData.zipMiles"
                        v-if="form.hospData.zipCode"
                        :options="milesData"
                        ref="zipMiles"
                        size="lg"
                        class="zipMilesSelect  ml-3"
                        :style="cusFontSizeSelect"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12">
                  <b-button
                      type="submit"
                      @click="form.FacilitySearch = 1"
                      class="col-6 col-sm-4 col-md-3 ml-3 btn btn-info btn-sm float-left"
                      :style="cusFontSizeSelect"
                      :disabled="loading"
                  >Search
                  </b-button>&nbsp;
                  <b-button
                      class="col-5 col-sm-3 btn btn-secondary btn-sm float-left ml-2"
                      @click="clearAll('hosp')"
                      :style="cusFontSizeSelect"
                      :disabled="loading"
                  >Clear
                  </b-button>
                  <div class="clearfix"></div>
                  <br>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <!--    <div class="float-left" :style="cusFontSize">Note: All provider offices speak English</div>-->
    <!--    <div class="clearfix"></div>-->
    <b-row v-if="providers.length>0 && providers[0].LastRefreshedAt" class="mt-0 p-0 mb-0">
      <b-col class="text-right text-dark">
        <small>Information as of {{
            new Date(providers[0].LastRefreshedAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
          }}</small>
        <div style="margin-top: -10px"><small v-if="providers.length>0 && checkPharmacyResult()">The Pharmacy Network may change at any time. You will receive notice when necessary.</small></div>
      </b-col>
    </b-row>
    <b-row  class="mt-0 p-0">
      <b-col class="text-right text-dark">

      </b-col>
    </b-row>
    <hr/>
    <b-row v-if="providers.length == 0 && loading">
      <b-col class="spinner">
        <semipolar-spinner :animation-duration="2000" :size="50" color="#25a7ce"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-12 pr-0" v-if="providers.length>0">
        <b-row class="mr-3 p-0 mb-3">
          <b-col cols="4" sm="4" md="4" lg="4" class="text-left pr-0">
            <b-row>
              <div class="d-inline customLabel align-self-center" :style="cusFontSize">Show&nbsp;</div>
              <b-form-select
                  id="input-1"
                  v-model="form.limit"
                  class="selectCust1"
                  :options="recordLimitData"
                  ref="zipMiles"
                  @change="searchProvider('P')"
              ></b-form-select>
              <div class="d-inline customLabel align-self-center" :style="cusFontSize">&nbsp;records.</div>
              <b-button class="btn-sm ml-1 p-1 align-self-center" variant="info" @click="generateResult" :disabled="fontSize==18"
                        href="javascript:;" target="_top">
                <i class="fa fa-file-pdf"></i> Export to PDF
              </b-button>
              <span class="align-self-center ml-2">
                <semipolar-spinner v-if="pdfLoading" class="align-self-center" :animation-duration="2000" :size="20" color="#25a7ce"/>
              </span>
            </b-row>
          </b-col>
          <b-col cols="8" sm="8" md="8" lg="8" class="float-right pr-0" :style="cusFontSize">
            <row>
              <b-button variant="info btn-sm col-3 col-sm-1 col-md-2 float-right ml-1" @click="searchProvider('N')"
                        v-if="recordCount>form.limit"><span :style="cusFontSize"
                                                            class="hiddenSm text-white font-weight-light">Next</span> <i
                  class="fas fa-angle-double-right"></i></b-button>

              <b-button variant="info btn-sm col-3 col-sm-1 col-md-2 float-right" @click="searchProvider('P')"
                        v-if="form.currentPage>0"><i class="fas fa-angle-double-left"></i> <span :style="cusFontSize"
                                                                                                 class="hiddenSm  text-white font-weight-light">Previous</span>
              </b-button>

              <span class="float-right mt-1 mr-1" :style="cusFontSize" style="font-weight: normal">
              <i class="fa fa-wheelchair"></i> Handicap Accessible |
              <i class="fa fa-medal"></i> Board Certified|
              <i class="fa fa-plus-circle"></i> Accepting New Patient
            </span>
            </row>
            <!--              <b-link class="text-success float-right" @click="searchProvider('N')" v-if="recordCount>form.limit"><i class="fas fa-caret-square-right"></i></b-link>-->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="text-left p-3" v-if="providers.length > 0">
      <b-card class="mb-3 col-12 provrow" v-for="(prov, index) in providers" :key="index" @click="emitProvDetails(prov)"
              :style="customCard">
        <b-card-text>
          <b-row>
            <b-col cols="12" class="col-sm-12 col-md-6">
              <b-row>
                <b-col class="col-12">
                  <div v-if="prov.ProviderKey !== 0">
                    <span :style="cusFontSize" class="font-weight-bold">Provider Name: </span>
                    <span :style="cusFontSize"
                          class="textDesc">{{ prov.ProviderFirstName }} {{ prov.ProviderLastName }}</span>
                    <span :style="cusFontSize" class="textDesc"
                          v-if="prov.PrimaryDegreeName">, {{ prov.PrimaryDegreeName }}</span><br/>
                  </div>
                  <div v-if="prov.ProviderKey !== 0">
                    <span :style="cusFontSize" class="font-weight-bold">Group/Clinic Name: </span>
                    <span :style="cusFontSize" class="textDesc">{{ prov.AddressName ? prov.AddressName : "N/A" }}</span>
                  </div>
                  <div v-if="prov.ProviderKey === 0">
                    <span :style="cusFontSize" class="font-weight-bold">Facility Name:&nbsp;</span>
                    <span :style="cusFontSize" class="textDesc">{{ prov.HospitalName }}<br/></span>
                  </div>
                  <span :style="cusFontSize" class="font-weight-bold" title="Address">
                      Address:
                    </span>
                  <span :style="cusFontSize" class="ml-1 font-weight-normal">
                      {{ prov.Street1 }}{{
                      prov.Street2 ? ', ' + prov.Street2 : ''
                    }}{{ prov.City ? ', ' + prov.City : '' }}{{ prov.State ? ', ' + prov.State : '' }}&nbsp;{{
                      prov.Zip
                    }}{{ prov.distance ? ', ' + prov.distance : '' }}
                      <b-link target="_blank" :href="prov.latLong"
                              v-if="prov.Street1 || prov.Street2 || prov.City || prov.State || prov.Zip">
                        <i class="fa fa-map-marker-alt"></i>Map
                      </b-link>
                      <span class="font-weight-normal"
                            v-if="!prov.Street1 && !prov.Street2 && !prov.City && !prov.State && !prov.Zip">N/A</span>
                    </span>
                  <br/>
                  <span :style="cusFontSize" class="font-weight-bold" title="Phone">
                      Phone:
                    </span>
                  <span :style="cusFontSize"
                        v-if="prov.Phone"
                        class="ml-1 font-weight-normal"
                  >{{ prov.Phone | VMask('(###)-###-####') }}</span>
                  <span :style="cusFontSize" v-if="!prov.Phone" class="ml-1 font-weight-normal">N/A</span>
                  <br/>
                  <span :style="cusFontSize" class="font-weight-bold" title="Fax">
                      Fax:
                    </span>
                  <span :style="cusFontSize"
                        v-if="prov.Fax"
                        class="ml-1 font-weight-normal"
                  >{{ prov.Fax | VMask('(###)-###-####') }}</span>
                  <span :style="cusFontSize" v-if="!prov.Fax" class="ml-1 font-weight-normal">N/A</span><br/>


                  <span v-if="prov.PrimarySpecialtyName && prov.PrimarySpecialtyName.trim().toUpperCase() === 'PHARMACY'">
                    <span :style="cusFontSize" class="font-weight-bold" >
                        Type:
                      </span>
                      <span :style="cusFontSize"  class="font-weight-normal" v-if="prov.PrimaryVendorCodeName">
                        {{ prov.PrimaryVendorCodeName }}
                        </span>
                      <span :style="cusFontSize"  class="font-weight-normal" v-if="!prov.PrimaryVendorCodeName">
                        N/A
                    </span><br/>

                    <span :style="cusFontSize" class="font-weight-bold" >
                        Prefered:
                      </span>
                      <span :style="cusFontSize"  class="font-weight-normal" v-if="prov.PCPContract">
                        {{ prov.PCPContract.trim().toUpperCase() === 'Y'?'Yes':'No' }}
                        </span>
                      <span :style="cusFontSize"  class="font-weight-normal" v-if="!prov.PCPContract">
                        N/A
                        </span>
                        <br/>
                  </span>


                  <span :style="cusFontSize" class="font-weight-bold" title="PCP" v-if="prov.IsPrimaryCarePhysician && prov.ProviderKey === 0">
                      Is PCP:
                    </span>
                  <span :style="cusFontSize" title="PCP" class="font-weight-normal" v-if="prov.IsPrimaryCarePhysician && prov.ProviderKey === 0">
                       {{ prov.IsPrimaryCarePhysician == 1 ? 'Yes' : 'No' }}<br/>
                  </span>
                  <div>
                      <span :style="largeFontSize" style="color: green; font-weight: bolder !important;"
                            title="Handicap Accessible" v-if="prov.WheelChairAccess === 1">
                          <i class="fa fa-wheelchair"></i>
                      </span>
                    <span :style="largeFontSize" style="color: #10707f; font-weight: bolder !important;"
                          :class="prov.WheelChairAccess === 1?'ml-2':''"
                          title="Board Certified" v-if="prov.ProviderKey !== 0 && prov.IsBoardCertified === 1">
                          <i class="fa fa-medal"></i>
                      </span>
                    <span :style="largeFontSize" style="color: #7171da;font-weight: bolder !important;"
                          :class="(prov.WheelChairAccess === 1 || prov.IsBoardCertified === 1)?'ml-2':''"
                          title="Accepting New Patient" v-if="prov.ProviderKey !== 0 && prov.AcceptingNewMember === 1">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" class="col-sm-12 col-md-6">
              <div v-if="prov.ProviderKey !== 0">
                <span :style="cusFontSize" class="font-weight-bold">Provider NPI:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc">{{ prov.NPI ? prov.NPI : 'N/A' }}<br/></span>
                <span :style="cusFontSize" class="font-weight-bold">Provider ID:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc">{{ prov.PCPIPAID ? prov.PCPIPAID : 'N/A' }}<br/></span>
                <span :style="cusFontSize" class="font-weight-bold" title="PCP">
                      Is PCP:
                    </span>
                <span :style="cusFontSize" title="PCP" class="font-weight-normal">
                       {{ prov.IsPrimaryCarePhysician == 1 ? 'Yes' : 'No' }}<br/>
                  </span>
                <!--                  <span :style="cusFontSize" class="font-weight-bold" title="PCP ID">-->
                <!--                      PCP ID:-->
                <!--                    </span>-->
                <!--                  <span :style="cusFontSize" title="PCP" class="font-weight-normal">-->
                <!--                       {{prov.PCPIPAID ? prov.PCPIPAID : 'N/A'}}<br/>-->
                <!--                  </span>-->
                <span :style="cusFontSize" class="font-weight-bold">Specialty:&nbsp;</span>
                <span class="textDesc" :style="cusFontSize">
                    {{
                    prov.PrimarySpecialtyName ? prov.PrimarySpecialtyName : ''
                  }}{{
                    prov.OtherSpecialtyName1 ? ', ' + prov.OtherSpecialtyName1 : ''
                  }} {{
                    prov.OtherSpecialtyName2 ? ', ' + prov.OtherSpecialtyName2 : ''
                  }} {{
                    prov.OtherSpecialtyName3 ? ', ' + prov.OtherSpecialtyName3 : ''
                  }} {{ prov.OtherSpecialtyName4 ? ', ' + prov.OtherSpecialtyName4 : '' }}<br/>
                  </span>
                <span :style="cusFontSize" class="font-weight-bold"
                      v-if="prov.ProviderKey !== 0">Language(s):&nbsp;</span>
                <span class="textDesc" :style="cusFontSize"
                      v-if="prov.ProviderKey !== 0">{{
                    prov.PrimaryLanguageName
                  }}{{ prov.SecondaryLanguageName ? ', ' + prov.SecondaryLanguageName : '' }}{{ prov.OtherLanguageName ? ', ' + prov.OtherLanguageName : '' }}<br/>
                  </span>
                <span v-if="prov.PrimarySpecialtyName && prov.PrimarySpecialtyName.trim().toUpperCase() != 'PHARMACY'">
                  <span :style="cusFontSize" class="font-weight-bold">Accepting Medicaid:&nbsp;</span>
                  <span :style="cusFontSize" class="textDesc">{{ prov.MedicaidID ? 'Yes' : 'No' }}</span>
                </span>

              </div>
              <div v-if="prov.ProviderKey === 0">
                <span :style="cusFontSize" class="font-weight-bold">Facility NPI:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc">{{ prov.NPI ? prov.NPI : 'N/A' }}<br/></span>
                <span :style="cusFontSize" class="font-weight-bold">Facility ID:&nbsp;</span>
                <span :style="cusFontSize" class="textDesc">{{ prov.ProviderID ? prov.ProviderID : 'N/A' }}<br/></span>
                <span :style="cusFontSize" class="font-weight-bold" title="IPA">
                      Facility Type:
                  </span>
                <span class="textDesc" :style="cusFontSize">
                    {{
                    prov.PrimaryVendorCodeName ? prov.PrimaryVendorCodeName : ''
                  }}{{
                    prov.OtherSpecialtyName1 ? (prov.PrimaryVendorCodeName?', ':'') + prov.OtherSpecialtyName1 : ''
                  }} {{
                    prov.OtherSpecialtyName2 ? ((prov.PrimaryVendorCodeName || prov.OtherSpecialtyName1)?', ':'') + prov.OtherSpecialtyName2 : ''
                  }} {{
                    prov.OtherSpecialtyName3 ? ((prov.PrimaryVendorCodeName || prov.OtherSpecialtyName1 || prov.OtherSpecialtyName2)?', ':'') + prov.OtherSpecialtyName3 : ''
                  }} {{
                    prov.OtherSpecialtyName4 ? ((prov.PrimaryVendorCodeName || prov.OtherSpecialtyName1 || prov.OtherSpecialtyName2 || prov.OtherSpecialtyName3)?', ':'') + prov.OtherSpecialtyName4 : ''
                  }}{{
                    (!prov.PrimaryVendorCodeName && !prov.OtherSpecialtyName1 && !prov.OtherSpecialtyName2 && !prov.OtherSpecialtyName3 && !prov.OtherSpecialtyName4)?'N/A':''
                  }}
                  <br/>

                </span>
                <span :style="cusFontSize" class="font-weight-bold">Specialty:&nbsp;</span>
                <span class="textDesc" :style="cusFontSize">
                    {{ prov.PrimarySpecialtyName ? prov.PrimarySpecialtyName : '' }}<br/>
                  </span>
                <span :style="cusFontSize" class="font-weight-bold" title="In Network">
                      In Network:
                    </span>
                <span :style="cusFontSize" title="In Network" class="font-weight-normal">
                       {{ prov.IsInNetwork === 1 ? 'Yes' : 'No' }}<br/>
                    </span>
                <span v-if="prov.PrimarySpecialtyName && prov.PrimarySpecialtyName.trim().toUpperCase() != 'PHARMACY'">
                  <span :style="cusFontSize" class="font-weight-bold">Accepting Medicaid:&nbsp;</span>
                  <span :style="cusFontSize" class="textDesc">{{ prov.MedicaidID ? 'Yes' : 'No' }}</span>
                </span>
              </div>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-row>
    <b-row>
      <b-col class="col-12 pr-0" v-if="providers.length>0">
        <b-row class="mr-3 p-0 mb-3">
          <b-col cols="3" sm="3" md="3" lg="3" class="col-4 text-left pr-1">
            <div class="d-inline customLabel" :style="cusFontSize">Show&nbsp;</div>
            <b-form-select
                id="input-1"
                v-model="form.limit"
                class="selectCust1"
                :options="recordLimitData"
                ref="zipMiles"
                @change="searchProvider('P')"
            ></b-form-select>
            <div class="d-inline customLabel" :style="cusFontSize">&nbsp;records.</div>
          </b-col>
          <b-col cols="9" sm="9" md="9" lg="9" class="float-right pr-0" :style="cusFontSize">
            <row>
              <b-button variant="info btn-sm col-2 col-sm-1 col-md-2 float-right ml-1" @click="searchProvider('N')"
                        v-if="recordCount>form.limit"><span :style="cusFontSize"
                                                            class="hiddenSm text-white font-weight-light">Next</span> <i
                  class="fas fa-angle-double-right"></i></b-button>

              <b-button variant="info btn-sm col-2 col-sm-1 col-md-2 float-right" @click="searchProvider('P')"
                        v-if="form.currentPage>0"><i class="fas fa-angle-double-left"></i> <span :style="cusFontSize"
                                                                                                 class="hiddenSm  text-white font-weight-light">Previous</span>
              </b-button>

              <span class="float-right mt-1 mr-1" :style="cusFontSize" style="font-weight: normal">
                <i class="fa fa-wheelchair"></i>  Handicap Accessible |
                <i class="fa fa-medal"></i>  Board Certified|
                <i class="fa fa-plus-circle"></i> Accepting New Patient
              </span>
            </row>
            <!--              <b-link class="text-success float-right" @click="searchProvider('N')" v-if="recordCount>form.limit"><i class="fas fa-caret-square-right"></i></b-link>-->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="searchFlag && !loading && searchCriteriaEntered">
      <b-col>
        <h4 class="text-center">
          No provider matched your specified search criteria.
          <br/>Please change your search criteria and try again.
        </h4>
        <!--          <h4>Please change the search parameters and try again.</h4>-->
      </b-col>
    </b-row>
    <b-row v-if="!searchCriteriaEntered && !loading">
      <b-col class="col-12 text-center">
        <h5 class="mt-2">Please enter at least one search criteria.</h5>
      </b-col>
    </b-row>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1056"
        filename="Provider Search List"
        :pdf-quality="2"
        image="{type: 'jpeg', quality: 1.00}"
        :manual-pagination="false"
        pdf-format="a4"
        ref="html2Pdf"
        :html-to-pdf-options=htmlToPdfOpts>
      <section slot="pdf-content">
        <provider-pdf slot="pdf-content" :providers="providers" :searchtype="form.FacilitySearch" :statenames="states" v-if="previewFlag"></provider-pdf>
      </section>
    </vue-html2pdf>
  </div>
  <!-- </ValidationObserver> -->
</template>
<script>
import ProviderSearchService from "../ProviderSearchService";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./../assets/js/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  AdvIcons: {
    normal: 'advicons.ttf'
  },
  Helvetica: {
    normal: 'Helvetica.ttf',
    bold: 'Helvetica-Bold.ttf',
    italics: 'Helvetica-Oblique.ttf',
    bolditalics: 'Helvetica-BoldOblique.ttf'
  }
}
// import { FormWizard } from "vue-form-wizard";
// import Multiselect from 'vue-multiselect'

import {extend} from "vee-validate";
//import { required, alpha } from "vee-validate/dist/rules";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";
import {SemipolarSpinner} from "epic-spinners";
import ProviderPdf from "./ProviderPdfComponent";
import VueHtml2pdf from 'vue-html2pdf'

extend("confirmEmail", {
  params: ["target"],
  validate(value, {target}) {
    return value === target;
  },
  message: "Email confirmation does not match"
});
extend("atleastone", {
  validate(value) {
    return value > 0;
  },
  message: "Please select at least one statement."
});
extend("min-phnum", {
  validate(value) {
    if (value) {
      let phonenumberonly = value
          .replace(/\(/g, "")
          .replace(/\)/g, "")
          .replace(/-/g, "");
      return phonenumberonly.length == 10;
    }
  },
  message: "{_field_} should always be 10 digits"
});
export default {
  name: "ProviderSearchNew",
  components: {
    SemipolarSpinner,
    ProviderPdf,
    VueHtml2pdf
  },
  props: {
    modalPopup: Boolean
  },
  data() {
    // const now = new Date();
    return {
      logoUrl: '',
      doctorUrl: window.location.origin + '/images/stethoscope.png',
      maleUrl: window.location.origin + '/images/male-doc.png',
      femaleUrl: window.location.origin + '/images/female-doc.png',
      hospitalUrl: window.location.origin + '/images/hospital.png',
      fontSize: 11,
      fontSizeSelect: 10,
      largeIconFontSize: 20,
      headerFontSize: 14,
      activeInstrument: "Piano",
      instruments: [],
      products: [],
      providers: [],
      recordCount: 0,
      hospital: [],
      saveResp: [],
      searchFlag: false,
      searchCriteriaEntered: true,
      showMenu: false,
      showHospitalMenu: false,
      showProductMenu: false,
      showSpecialtyMenuProv: false,
      showSpecialtyMenuHosp: false,
      showLanguageMenuProv: false,
      showIPAMenuProv: false,
      previewFlag: false,
      showLanguageMenuHosp: false,
      showFTMenuHosp: false,
      showGenderMenu: false,
      showStateMenuProv: false,
      showStateMenuHosp: false,
      showCountyMenuProv: false,
      showCountyMenuHosp: false,
      center: {},
      markers: [],
      languageFilterProv: [],
      languageFilterHosp: [],
      stateFilterProv: [],
      stateFilterHosp: [],
      countyFilterProv: [],
      countyFilterHosp: [],
      ipaFilterProv: [],
      facilityTypeFilterHosp: [],
      orgLanguages: [],
      languageInputProv: "",
      languageInputHosp: "",
      ipaInputProv: "",
      facilityTypeInputHosp: "",
      stateInputProv: "",
      stateInputHosp: "",
      countyInputProv: "",
      countyInputHosp: "",
      specialtyFilterProv: [],
      specialtyFilterProvGrp: [],
      specialtyFilterHosp: [],
      specialtyFilterHospGrp: [],
      orgSpecProv: [],
      orgSpecHosp: [],
      specialtyInputProv: "",
      specialtyInputHosp: "",
      loading: false,
      showDownloadBtn: false,
      provSpecInGrp: false,
      hospSpecInGrp: false,
      downloadUrl: "",
      provCountyList:[],
      hospCountyList:[],
      milesData: [
        //{ text: "", value: "" },
        {text: "5 Miles", value: "5"},
        {text: "10 Miles", value: "10"},
        {text: "15 Miles", value: "15"},
        {text: "20 Miles", value: "20"},
        {text: "25 Miles", value: "25"},
        {text: "30 Miles", value: "30"},
        {text: "50 Miles", value: "50"},
      ],
      recordLimitData: [
        {text: "10", value: "10"},
        {text: "20", value: "20"},
        {text: "30", value: "30"},
        {text: "40", value: "40"},
        {text: "50", value: "50"}
      ],
      form: {
        provData: {
          language: [],
          gender:[],
          specialty: [],
          addressName: "",
          ipa: [],
          state: [],
          county: [],
          zipCode: "",
          zipMiles: 5,
        },
        hospData: {
          specialty: [],
          language: [],
          facilityType: [],
          state: [],
          county: [],
          zipCode: "",
          zipMiles: 5,
        },
        providername: "",
        hospital: "",
        zipCode: "",
        zipMiles: 5,
        products: [],
        language: [],
        provSpecialty: [],
        hospSpecialty: [],
        zipCodes: [],
        newpatient: [],
        wheelchair: [],
        translator: [],
        gender: [],
        age: "",
        currentPage: 0,
        limit: 50,
        offset: 0
      },
      states:[],
      htmlToPdfOpts : {
        margin: [20,10,35,10],
        filename: 'file.pdf',
        html2canvas: {
          scale: 2, letterRendering: true
        },
        pagebreak: { mode: '', before: '.break-before', after: '.break-after', avoid: '.break-avoid' },
        jsPDF: {unit: 'pt', format: 'a4', orientation: 'portrait'
        }
      },
      specialties: [],
      statesPdf: [],
      counties: [],
      provReportList:[],
      selectedReport:{},
      pdfLoading: false,
      disableProvCounty: true,
      disableHospCounty: true
    };
  },
  async created() {
    try {
      document.title = "Provider Directory Search"
      if (process.env.VUE_APP_CLIENT) {
        this.logoUrl = window.location.origin + '/images/logos/' + process.env.VUE_APP_CLIENT + '.png';
      } else {
        this.logoUrl = window.location.origin + '/images/logos/logo.png';
      }
      this.products = await ProviderSearchService.getProducts();
      this.states = await ProviderSearchService.getStates();
      this.countyList = await ProviderSearchService.getCounties();
      if(process.env.VUE_APP_CLIENT && process.env.VUE_APP_CLIENT.toUpperCase() === 'CSH'){
        let repoList = await ProviderSearchService.getReportConfiguration();
        if(repoList.length > 0){
          this.provReportList = [];
          this.provReportList.push({text:'Select Print Directory Front Matter', value:{}});
          for(let i of repoList) {
            let item = {text: i.ReportName, value:i};
            this.provReportList.push(item);
          }
        }
      }
      this.countyFilterProv = JSON.parse(JSON.stringify(this.countyList));
      this.countyFilterHosp = JSON.parse(JSON.stringify(this.countyList));
      this.orgCounties = JSON.parse(JSON.stringify(this.countyList));
      this.stateFilterProv = this.states;
      this.stateFilterHosp = JSON.parse(JSON.stringify(this.stateFilterProv));
      this.orgStates = JSON.parse(JSON.stringify(this.stateFilterProv));
      this.languageFilterProv = await ProviderSearchService.getLanguages();
      this.languageFilterHosp = JSON.parse(JSON.stringify(this.languageFilterProv));

      this.orgLanguages = JSON.parse(JSON.stringify(this.languageFilterProv));
      //this.ipaFilterProv = await ProviderSearchService.getIPAs();
      this.facilityTypeFilterHosp = await ProviderSearchService.getIPAs();
      this.orgFacilityTypes = JSON.parse(JSON.stringify(this.facilityTypeFilterHosp));
      this.specialtyFilterProvGrp = await ProviderSearchService.getProvGrpSpecialities();
      if (this.specialtyFilterProvGrp.length > 0) {
        this.hospSpecInGrp = true;
        this.provSpecInGrp = true;
        this.specialtyFilterProv = this.specialtyFilterProvGrp;
      } else {
        this.specialtyFilterProv = await ProviderSearchService.getProvSpecialities();
        this.specialtyFilterHosp = await ProviderSearchService.getHospSpecialities();
      }
      this.orgSpecProv = JSON.parse(JSON.stringify(this.specialtyFilterProv));
      //this.orgSpecProvGrp = JSON.parse(JSON.stringify(this.specialtyFilterProvGrp));
      this.orgSpecHosp = JSON.parse(JSON.stringify(this.specialtyFilterHosp));
      //this.orgSpecHospGrp = JSON.parse(JSON.stringify(this.specialtyFilterHospGrp));
      if (this.$route.params.id) {
        var tempProd = window.atob(this.$route.params.id);
        tempProd = tempProd.split(',');
        this.form.products = tempProd;
      }
      let getDirectoryFile = await ProviderSearchService.getDirectoryFile();
      if (getDirectoryFile.length > 0 && getDirectoryFile[0].signedURL) {
        this.showDownloadBtn = true;
        this.downloadUrl = getDirectoryFile[0].signedURL;
      } else {
        this.showDownloadBtn = false;
      }

    } catch (err) {
      this.error = err.message;
    }
  },
  methods: {
    setReport(selReport){
      let states = (selReport.ReportParams && JSON.parse(selReport.ReportParams).state) ?  JSON.parse(selReport.ReportParams).state:[];
      if(JSON.stringify(this.form.provData.state)!= JSON.stringify(states) && JSON.stringify(this.form.hospData.state)!= JSON.stringify(states)) {
        this.clearAll('HOSP');
        this.clearAll('PROV');
        if (selReport.ReportParams && JSON.parse(selReport.ReportParams).state) {
          this.form.hospData.state = JSON.parse(selReport.ReportParams).state;
          this.form.provData.state = JSON.parse(selReport.ReportParams).state;
        } else {
          this.form.hospData.state = [];
          this.form.provData.state = [];
        }
      }
    },
    getLangName(lang) {
      var selLang = this.orgLanguages.filter(function (item) {
        return item.value === lang;
      });
      return selLang[0].text;
    },
    getFacilityTypeName(ft) {
      var selFT = this.orgFacilityTypes.filter(function (item) {
        return item.value === ft;
      });
      return selFT[0].text;
    },
    getStateName(st) {
      var selIPA = this.orgStates.filter(function (item) {
        return item.State === st;
      });
      return selIPA.length>0 ? selIPA[0].StateName : "";
    },
    getCountyList(type,searchInput) {
      let finalArr = [];
      let countyList = [];
      if(searchInput){
        this.orgCounties.forEach(element => {
          var elementLowercase = element.County ? element.County.toLowerCase() : "";
          var searchValLowercase = searchInput.toLowerCase();
          if (elementLowercase.includes(searchValLowercase)) {
            countyList.push(element);
          }
        });
      }else{
        countyList =this.orgCounties;
      }
      if(type=='prov'){
        if(this.form.provData.state.length>0){
          this.form.provData.state.forEach((stateVal) => {
            countyList.forEach(countyVal => {
              let stateList = countyVal.States ? JSON.parse(countyVal.States) : [];
              stateList = [...new Set(stateList)]
              stateList.forEach(st=>{
                if(stateVal==st){
                  finalArr.push(countyVal);
                }
              })
            })
          });
          finalArr = [...new Set(finalArr)];
        }else{
          finalArr = countyList;
        }
        this.provCountyList = finalArr;
        return finalArr;
      }else if(type=='hosp'){
        if(this.form.hospData.state.length>0){
          this.form.hospData.state.forEach((stateVal) => {
            countyList.forEach(countyVal => {
              let stateList = countyVal.States ? JSON.parse(countyVal.States) : [];
              stateList = [...new Set(stateList)];
              stateList.forEach(st=>{
                if(stateVal==st){
                  finalArr.push(countyVal);
                }
              })
            })
          });
          finalArr = [...new Set(finalArr)];
        }else{
          finalArr = countyList;
        }
        this.hospCountyList = finalArr;
        return finalArr
      }else{
        return [];
      }
    },
    getHospSpecialty(spec) {
      var selHosp = this.orgSpecHosp.filter(function (item) {
        return item.value === spec;
      });
      return selHosp[0].text;
    },
    getProvSpecialty(spec) {
      var selProv = this.orgSpecProv.filter(function (item) {
        return item.value === spec;
      });
      return selProv[0].text;
    },
    clickCallback(pageNum) {
      console.log(pageNum)
    },
    removeSearchParamsNotForFacility() {
      this.form.language = [];
      this.form.gender = [];
      this.form.newpatient = [];
      this.form.ageband = "";
      this.form.providername = "";
    },
    emitProvDetails(prov) {
      if (this.modalPopup) {
        this.$emit('providerselected', prov);
      }
    },
    nameWithLang({name, language}) {
      return `${name} — [${language}]`;
    },
    removeDetails: function (checkVal, remArr) {
      //alert(checkVal)
      if (checkVal === "Y") {
        remArr.forEach(item => {
          delete this.form[item];
        });
      }
    },
    limitText(count) {
      return `and ${count} other countries`;
    },

    clearAll(type) {
      if (type == 'prov') {
        this.form.provData = {
          language: [],
          specialty: [],
          gender: [],
          state: [],
          county: [],
          zipCode: "",
          zipMiles: 5,
        };
        this.form.provSpecialty = [];
        this.specialtyInputProv = "";
        this.languageInputProv = "";
      }
      if (type == 'hosp') {
        this.form.hospData = {
          specialty: [],
          language: [],
          facilityType: [],
          state: [],
          county: [],
          zipCode: "",
          zipMiles: 5,
        };
        this.form.hospSpecialty = [];
        this.specialtyInputHosp = "";
        this.languageInputHosp = "";
        this.facilityTypeInputHosp = "";
      }
      this.selectedCountries = [];
      (this.instruments = []), (this.form.products = []);
      this.form.hospital = "";
      this.form.providername = "";
      this.form.zipCode = "";
      this.form.zipMiles = 5;
      this.form.originLatLong = [];
      this.form.specialty = [];
      this.form.language = [];
      this.form.gender = [];
      this.searchFlag = false;
      this.searchCriteriaEntered = true;
      this.languageInput = "";
      this.specialtyInput = "";
      this.providers = [];
      this.recordCount = 0;
      this.searchLang(this.languageInputProv, 'prov');
      this.searchLang(this.languageInputHosp, 'hosp');
      //this.searchIPA(this.ipaInputProv, 'prov');
      this.searchIPA(this.facilityTypeInputHosp, 'hosp');
      this.searchSpec(this.specialtyInputProv, 'prov');
      this.searchSpec(this.specialtyInputHosp, 'hosp');
      // if(this.selectedReport.ReportParams && JSON.parse(this.selectedReport.ReportParams).state){
      //   this.form.hospData.state = JSON.parse(this.selectedReport.ReportParams).state;
      //   this.form.provData.state = JSON.parse(this.selectedReport.ReportParams).state;
      // }else{
      //   this.form.hospData.state = [];
      //   this.form.provData.state = [];
      // }
      this.selectedReport = {text:'Select Print Directory Front Matter', value:{}};
      this.disableProvCounty = this.disableHospCounty = true;
    },
    searchProvider: async function (linkType) {
      this.form.ProviderOnly = this.modalPopup;
      if (linkType == 'N') {
        this.form.currentPage += 1;
      } else if (linkType == 'P') {
        if (this.form.currentPage > 0) {
          this.form.currentPage -= 1;
        }
      } else {
        this.form.currentPage = 0;
      }
      this.form.offset = this.form.limit * this.form.currentPage;
      this.loading = true;
      this.providers = [];
      this.form.zipCodes = [];
      this.form.originLatLong = [];
      if (this.form.FacilitySearch === 0) {
        if (this.provSpecInGrp) {
          let selCodeGrp = [];
          for (let i of this.form.provData.specialty) {
            for (let j of this.orgSpecProv) {
              if (i === j.value) {
                selCodeGrp.push(...j.CodeList)
              }
            }
          }
          this.form.provSpecialty = selCodeGrp.length > 0 ? selCodeGrp : [];
        } else {
          this.form.provSpecialty = this.form.provData.specialty ? this.form.provData.specialty : [];
        }
        this.form.language = this.form.provData.language ? this.form.provData.language : [];
        this.form.gender = this.form.provData.gender ? this.form.provData.gender : [];
        this.form.ipa = this.form.provData.ipa ? this.form.provData.ipa : [];
        this.form.state = this.form.provData.state ? this.form.provData.state : [];
        this.form.county = this.form.provData.county ? this.form.provData.county : [];
        this.form.zipCode = this.form.provData.zipCode ? this.form.provData.zipCode : "";
        this.form.zipMiles = this.form.provData.zipMiles ? this.form.provData.zipMiles : 5;
        this.form.ProviderFirstName = this.form.provData.ProviderFirstName;
        this.form.ProviderLastName = this.form.provData.ProviderLastName;
        this.form.AddressName = this.form.provData.addressName;
        this.form.PCPOnly = this.form.provData.PCPOnly;
        this.form.hospital = "";
      }
      if (this.form.FacilitySearch === 1) {
        this.form.ProviderFirstName = "";
        this.form.ProviderLastName = "";
        if (this.hospSpecInGrp) {
          let selCodeGrp = [];
          for (let i of this.form.hospData.specialty) {
            for (let j of this.orgSpecHosp) {
              if (i === j.value) {
                selCodeGrp.push(...j.CodeList)
              }
            }
          }
          this.form.hospSpecialty = selCodeGrp.length > 0 ? selCodeGrp : [];
        } else {
          this.form.hospSpecialty = this.form.hospData.specialty ? this.form.hospData.specialty : [];
        }
        this.form.language = this.form.hospData.language ? this.form.hospData.language : [];
        this.form.facilityType = this.form.hospData.facilityType ? this.form.hospData.facilityType : [];
        this.form.state = this.form.hospData.state ? this.form.hospData.state : [];
        this.form.county = this.form.hospData.county ? this.form.hospData.county : [];
        this.form.zipCode = this.form.hospData.zipCode ? this.form.hospData.zipCode : "";
        this.form.zipMiles = this.form.hospData.zipMiles ? this.form.hospData.zipMiles : 5;
        this.form.hospital = this.form.hospData.hospital;
      }
      if (
          (this.form.FacilitySearch === 1 && (this.form.hospital || this.form.hospSpecialty.length > 0 || this.form.zipCode || this.form.facilityType.length > 0 || this.form.state.length > 0 || this.form.county.length > 0)) ||
          (this.form.FacilitySearch === 0 && (this.form.ProviderFirstName || this.form.ProviderLastName || this.form.provSpecialty.length > 0 || this.form.language.length > 0 || this.form.zipCode || this.form.AddressName || this.form.gender.length > 0 || this.form.state.length > 0 || this.form.county.length > 0 || this.form.PCPOnly === '1'))
      ) {
        this.searchCriteriaEntered = true;
        this.saveResp = await ProviderSearchService.getNearByZipCodes(
            this.form.zipCode,
            this.form.zipMiles
        );
        if (this.saveResp.length > 0) {
          this.center = this.saveResp[0].center;
          this.form.originLatLong = this.center;
          this.markers.push({
            position: this.saveResp[0].center,
            distance: "Your Zip Code, 0.00 miles",
            icon: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
          });
          this.saveResp.forEach(element => {
            this.form.zipCodes.push(element.zipcode);
            this.markers.push;
          });
        }
        var providerList = await ProviderSearchService.findProvider(this.form);

        this.providers = providerList[0].records;
        this.recordCount = providerList[0].count;
        if (this.providers.length > 0) {
          this.providers.forEach((pro, idx) => {
            this.providers[idx].latLong =
                "http://www.google.com/maps/search/?api=1&query=" + pro.Street1 + ' ' + (pro.Street2 ? pro.Street2 + ' ' : '') + pro.City + ' ' + pro.State + ' ' + pro.Zip + ' ';
            this.saveResp.forEach(element => {
              if (pro.Zip == element.zipcode) {
                this.providers[idx].distance =
                    element.miles.toFixed(2) + " miles";
              }
            });
          });
          this.searchFlag = false;
          this.loading = false;
        } else {
          this.searchFlag = true;
          this.loading = false;
        }
      } else {
        this.searchCriteriaEntered = false;
        this.loading = false;
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    changeInstrument: function (instrument) {
      this.activeInstrument = instrument;
    },
    toggleShow: function (val, type) {
      if (val == "hospital") {
        this.showHospitalMenu = !this.showHospitalMenu;
      }
      if (val == "product") {
        this.showProductMenu = !this.showProductMenu;
      }
      if (val == "specialty") {
        if (type === 'prov') {
          this.showSpecialtyMenuProv = !this.showSpecialtyMenuProv;
        }
        if (type === 'hosp') {
          this.showSpecialtyMenuHosp = !this.showSpecialtyMenuHosp;
        }
      }
      if (val == "language") {
        if (type === 'prov') {
          this.showLanguageMenuProv = !this.showLanguageMenuProv;
        }
        if (type === 'hosp') {
          this.showLanguageMenuHosp = !this.showLanguageMenuHosp;
        }
      }
      if (val == "state") {
        if (type === 'prov') {
          this.showStateMenuProv = !this.showStateMenuProv;
        }
        if (type === 'hosp') {
          this.showStateMenuHosp = !this.showStateMenuHosp;
        }
      }
      if (val == "gender") {
        this.showGenderMenu = !this.showGenderMenu;
      }
      if (val == "facilityType") {
        if (type === 'prov') {
          this.showIPAMenuProv = !this.showIPAMenuProv;
        }
        if (type === 'hosp') {
          this.showFTMenuHosp = !this.showFTMenuHosp;
        }
      }
      if (val == "county") {
        if (type === 'prov') {
          this.showCountyMenuProv = !this.showCountyMenuProv;
        }
        if (type === 'hosp') {
          this.showCountyMenuHosp = !this.showCountyMenuHosp;
        }
      }
    },
    itemClicked: function (item) {
      this.toggleShow();
      this.onClick(item);
    },
    mouseOut: function (val, type) {
      this.active = false;
      this.showMenu = false;
      if (val == "specialty") {
        if (type == 'prov') {
          this.showSpecialtyMenuProv = false;
        }
        if (type == 'hosp') {
          this.showSpecialtyMenuHosp = false;
        }
      }
      if (val == "language") {
        if (type == 'prov') {
          this.showLanguageMenuProv = false;
        }
        if (type == 'hosp') {
          this.showLanguageMenuHosp = false;
        }
      }
      if (val == "facilityType") {
        if (type == 'prov') {
          this.showIPAMenuProv = false;
        }
        if (type == 'hosp') {
          this.showFTMenuHosp = false;
        }
      }
      if (val == "state") {
        if (type == 'prov') {
          this.showStateMenuProv = false;
        }
        if (type == 'hosp') {
          this.showStateMenuHosp = false;
        }
      }
      if (val == "county") {
        if (type == 'prov') {
          this.showCountyMenuProv = false;
        }
        if (type == 'hosp') {
          this.showCountyMenuHosp = false;
        }
      }
      if(val=="gender"){
        this.showGenderMenu = false;
      }
    },
    removeThis: function (key, modelArr, type) {
      let states = (this.selectedReport.ReportParams && JSON.parse(this.selectedReport.ReportParams).state) ?  JSON.parse(this.selectedReport.ReportParams).state:[];
      if(JSON.stringify(modelArr) == JSON.stringify(states)){
        this.selectedReport = {text:'Select Print Directory Front Matter', value:{}};
      }
      modelArr.splice(key, 1);
      if(type){
        this.setDirectoryFrontMatter(type==='prov'?this.form.provData:this.form.hospData);
      }
      this.disableProvCounty = this.form.provData.state.length>0 ? false:true;
      this.disableHospCounty = this.form.hospData.state.length>0 ? false:true;
    },
    checkPharmacyResult(){
      if(this.form.hospData.specialty.length === 1 && this.getHospSpecialty(this.form.hospData.specialty[0]).toUpperCase() === 'PHARMACY'){
        return true;
      }else{
        return false;
      }
    },
    async generateResult () {
      this.pdfLoading = true;
      await this.checkForReport(this.form, this.form.FacilitySearch === 1?'hosp':'prov');
      this.specialties =[];
      this.statesPdf= [];
      this.counties= [];
      let primaryCareProviders = {specialties:[],statesPdf:[], counties:[]};
      let specialists = {specialties:[],statesPdf:[], counties:[]};
      let hasPharmacy = this.checkPharmacyResult();
      if (this.providers.length > 0) {
        this.providers.sort((a, b) => (a.ProviderFirstName+a.ProviderLastName).localeCompare(b.ProviderFirstName+b.ProviderLastName) );
        for (let item of this.providers) {
          if (item.IsPrimaryCarePhysician == 1 && this.form.FacilitySearch !== 1 && primaryCareProviders.specialties.indexOf(item.PrimarySpecialtyName) === -1) {
            primaryCareProviders.specialties.push(item.PrimarySpecialtyName);
          }
          if (item.IsPrimaryCarePhysician != 1 && this.form.FacilitySearch !== 1 && specialists.specialties.indexOf(item.PrimarySpecialtyName) === -1) {
            specialists.specialties.push(item.PrimarySpecialtyName);
          }
          if (this.form.FacilitySearch === 1 && this.specialties.indexOf(item.DirectoryCategory) === -1) {
            this.specialties.push(item.DirectoryCategory);
          }
          let pcpStateItemExists = false;
          let spStateItemExists = false;
          let hospStateItemExists = false;
          let stateItem ={}
          if (this.form.FacilitySearch !== 1) {
            stateItem = {state: item.State, specialty: item.PrimarySpecialtyName}
            if(item.IsPrimaryCarePhysician == 1) {
              for (let i = 0; i < primaryCareProviders.statesPdf.length; i++) {
                if (primaryCareProviders.statesPdf[i].state == stateItem.state
                    && primaryCareProviders.statesPdf[i].specialty == stateItem.specialty) {
                  pcpStateItemExists = true;
                }
              }
              if (!pcpStateItemExists && item.State) {
                primaryCareProviders.statesPdf.push(stateItem);
              }
            }else{
              for (let i = 0; i < specialists.statesPdf.length; i++) {
                if (specialists.statesPdf[i].state == stateItem.state
                    && specialists.statesPdf[i].specialty == stateItem.specialty) {
                  spStateItemExists = true;
                }
              }
              if (!spStateItemExists && item.State) {
                specialists.statesPdf.push(stateItem);
              }
            }
          }else{
            stateItem = {state: item.State, specialty: item.DirectoryCategory}
            for (let i = 0; i < this.statesPdf.length; i++) {
              if (this.statesPdf[i].state == stateItem.state && this.statesPdf[i].specialty == stateItem.specialty) {
                hospStateItemExists = true;
              }
            }
            if (!hospStateItemExists && item.State) {
              this.statesPdf.push(stateItem);
            }
          }
          let pcpCountyItemExists = false;
          let spCountyItemExists = false;
          let hospCountyItemExists = false;
          let countyItem = {};
          if (this.form.FacilitySearch !== 1) {
            countyItem = {state: item.State, county: item.County, specialty: item.PrimarySpecialtyName};
            if(item.IsPrimaryCarePhysician == 1) {
              for (let i = 0; i < primaryCareProviders.counties.length; i++) {
                if (primaryCareProviders.counties[i].state == countyItem.state
                    && primaryCareProviders.counties[i].county == countyItem.county && primaryCareProviders.counties[i].specialty == countyItem.specialty) {
                  pcpCountyItemExists = true;
                }
              }
              if (!pcpCountyItemExists && item.County) {
                primaryCareProviders.counties.push(countyItem);
              }
            }else{
              for (let i = 0; i < specialists.counties.length; i++) {
                if (item.IsPrimaryCarePhysician != 1 && specialists.counties[i].state == countyItem.state
                    && specialists.counties[i].county == countyItem.county && specialists.counties[i].specialty == countyItem.specialty) {
                  spCountyItemExists = true;
                }
              }
              if (!spCountyItemExists && item.County) {
                specialists.counties.push(countyItem);
              }
            }
          }else{
            countyItem = {state: item.State, county: item.County, specialty: item.DirectoryCategory};
            for (let i = 0; i < this.counties.length; i++) {
              if (this.counties[i].state == countyItem.state && this.counties[i].county == countyItem.county && this.counties[i].specialty == countyItem.specialty) {
                hospCountyItemExists = true;
              }
            }

            if (!hospCountyItemExists && item.County) {
              this.counties.push(countyItem);
            }
          }
        }
        if (this.form.FacilitySearch !== 1){
          primaryCareProviders.specialties.sort((a, b) => a.localeCompare(b));
          specialists.specialties.sort((a, b) => a.localeCompare(b));
          this.specialties.sort((a, b) => a.localeCompare(b));
        }
        primaryCareProviders.statesPdf.sort((a, b) => a.state.localeCompare(b.state));
        specialists.statesPdf.sort((a, b) => a.state.localeCompare(b.state));
        primaryCareProviders.counties.sort((a, b) => a.county.localeCompare(b.county));
        specialists.counties.sort((a, b) => a.county.localeCompare(b.county));
        this.statesPdf.sort((a, b) => a.state.localeCompare(b.state));
        this.counties.sort((a, b) => a.county.localeCompare(b.county));
      }
      let reportContent = {};
      if(this.selectedReport && this.selectedReport.ReportKey && !hasPharmacy) {
        let data = await ProviderSearchService.getReportContent(this.selectedReport.ReportKey);
        if(data[0].ReportKey){
          const updateDate = new Date(this.providers[0].LastRefreshedAt).toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'});
          const updateYear = new Date(this.providers[0].LastRefreshedAt).getFullYear();
          let modifiedContent = data[0].ReportContent.replace(/<year>/g,updateYear).replace(/<last_update>/g,updateDate);
          reportContent = JSON.parse(modifiedContent);
        }
      }
      let footerText = reportContent.footer?reportContent.footer:(process.env.VUE_APP_CLIENT.toUpperCase()+' Provider Directory');
      if (hasPharmacy){
        footerText += '\nThe Pharmacy Network may change at any time. You will receive notice when necessary.';
      }
      let dd = {
        info: {
          title: 'Provider Directory Search Result'
        },
        header: function(cp){
          if((cp != 1 && reportContent.header) || !reportContent.header){
            return [
              {
                columns:[
                  {
                    text: reportContent.header?reportContent.header:(process.env.VUE_APP_CLIENT.toUpperCase()+' Provider Directory'),
                    width: 538
                  },
                  { text: cp.toString() , fontSize: 12, bold: true}
                ],
                margin: [10, 15, 10, 5],
                color: '#31849B'
              },
              {canvas: [{ type: 'line', x1: 5, y1: 5, x2: 595-5, y2: 5, lineWidth: 0.5 }]}
            ]
          }
        },
        footer: function (cp, pages) {
          if((reportContent.footer && cp > 1) || !reportContent.footer){
            let result = [
              {
                canvas: [{
                  type: 'line',
                  x1: 5,
                  y1: 5,
                  x2: 595 - 5,
                  y2: 5,
                  lineWidth: 1
                }
                ]
              }, {
                columns: [
                  {text: footerText, style:'small', width: 200}
                ]
              }
            ];
            if((cp > 5 && cp != pages && cp != pages-1) || !reportContent.footer){
              result[1]['columns'].push({
                text: [{
                  text: '',
                  style: ['icon', 'small']
                },
                  'Handicap Accessible\t', {
                    text: '',
                    style: ['icon', 'small']
                  },
                  'Board Certified\t',{
                    text: '',
                    style: ['icon', 'small']
                  },
                  'Accepting New Patients\t', {
                    text: 'M',
                    fontSize: 8,
                    bold: true
                  },
                  'Accept Medicaid'
                ],
                style: 'small',
                alignment: 'right'
              })
            }
            return result;
          }else{
            if(reportContent.footer){
              return {text:reportContent.footer, style:'small', width: 200}
            }
          }
        },
        pageSize: 'letter',
        content: reportContent.content && reportContent.content != null?reportContent.content:[],
        pageBreakBefore: function(currentNode, followingNodesOnPage) {
          return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
        },
        defaultStyle: {
          font: 'Helvetica'
        },
        styles: {
          header: {
            fontSize: 20,
            bold: true,
            margin: [0, 10, 0, 0]
          },
          headerBold: {
            fontSize: 12,
            bold: true,
            margin: [0, 10, 0, 0]
          },
          super_header: {
            fontSize: 50,
            bold: true,
            margin: [0, 10, 0, 0]
          },
          small: {
            fontSize: 8,
            margin: [10, 5, 10, 0]
          },
          icon: { font: 'AdvIcons' },
          item_header: {
            fontSize: 18,
            bold: true,
            margin: [10, 0, 0, 0]
          },
          item_sub_header: {
            fontSize: 16,
            bold: true,
            margin: [20, 0, 0, 0]
          },
          item_sub_header2: {
            fontSize: 14,
            bold: true,
            margin: [30, 0, 0, 0]
          },
          normal: {
            fontSize: 12,
            margin: [40, 0, 0, 0]
          }
        }

      }
      if(this.form.FacilitySearch !== 1) {
        if(primaryCareProviders.specialties.length > 0){
          let pcpHeader = {
            table: {
              widths:[310],
              body: [
                [{
                  border: [false, false, false, false],
                  fillColor: '#000000',
                  text:'Primary Care Providers (PCPs)',
                  tocItem: 'mainToc'
                }]
              ]
            }, style: 'header',
            color: '#ffffff'}
          dd.content.push(pcpHeader);
          dd.content.push("\n");
          let pcpsProvs = [];
          for(let i of this.providers){
            if(i.IsPrimaryCarePhysician == 1){
              pcpsProvs.push(i);
            }
          }
          this.populateDDContent(dd,primaryCareProviders, pcpsProvs);
        }

        if(specialists.specialties.length > 0){
          let spHeader = {
            table: {
              widths:[310],
              body: [
                [{
                  border: [false, false, false, false],
                  fillColor: '#000000',
                  text:'Specialists',
                  tocItem: 'mainToc'
                }]
              ]
            }, style: 'header',
            color: '#ffffff'}
          dd.content.push(spHeader);
          dd.content.push("\n");
          let spProvs = [];
          for(let i of this.providers){
            if(i.IsPrimaryCarePhysician != 1){
              spProvs.push(i);
            }
          }
          this.populateDDContent(dd,specialists, spProvs);
        }

      }else{
        this.populateDDContent(dd, {specialties:this.specialties,statesPdf: this.statesPdf, counties: this.counties}, this.providers)
      }
      if(reportContent.language_content && reportContent.language_content.length > 0){
        dd.content.push(reportContent.language_content);
      }
      if(reportContent.non_discrimination_content && reportContent.non_discrimination_content.length > 0){
        dd.content.push(reportContent.non_discrimination_content);
      }
      this.pdfLoading = false;
      pdfMake.createPdf(dd).open();
    },

    populateDDContent: function(dd, grpItem, provListToIterate){
      for (let sp of grpItem.specialties) {
        let headerText = {
          table: {
            widths:[300],
            body: [
              [{
                border: [false, false, false, false],
                fillColor: '#928d8d',
                text: sp
              }]
            ]
          },
          style: 'item_header',
          color: '#ffffff'
        }
        if(this.form.FacilitySearch === 1){
          headerText.table.body[0][0].tocItem = 'mainToc';
          headerText.table.body[0][0].fillColor = '#000000';
        }
        dd.content.push(headerText);
        for (let st of grpItem.statesPdf) {
          if (st.specialty === sp) {
            if(!this.selectedReport.ReportKey) {
              let stateText = {text: this.getStateName(st.state), style: 'item_sub_header'};
              dd.content.push(stateText);
            }
            for (let county of grpItem.counties) {
              if (county.state === st.state && county.specialty === sp) {
                let countyText = {text: county.county, style: 'item_sub_header2'};
                dd.content.push(countyText);
                dd.content.push("\n");
                provListToIterate[0].st_distance?provListToIterate.sort((a, b) => a.st_distance-b.st_distance):provListToIterate;
                for (let prov of provListToIterate) {
                  if(this.form.FacilitySearch !== 1) {
                    if (prov.County === county.county && prov.State === st.state && prov.PrimarySpecialtyName == sp) {
                      let nameText = {
                        text: prov.ProviderFirstName + ' ' + prov.ProviderLastName + (prov.PrimaryDegreeName ? ', ' + prov.PrimaryDegreeName : ''),
                        style: 'normal'
                      };
                      dd.content.push(nameText);
                      let streetText = {
                        text: prov.Street1 + (prov.Street2 ? ', ' + prov.Street2 : ''),
                        style: 'normal'
                      };
                      if(prov.AddressName) {
                        let addressNameText = {
                          text: [
                            {
                              text: prov.AddressName
                            }
                          ],
                          style: 'normal'
                        };
                        dd.content.push(addressNameText);
                      }
                      dd.content.push(streetText);
                      let cityStateZipText = {
                        text: [{text: prov.City + (prov.State ? ', ' + prov.State : '') + (prov.Zip ? ', ' + prov.Zip : '') + (prov.distance ? ', ' + prov.distance : '')}],
                        style: 'normal'
                      };
                      if (prov.Phone) {
                        dd.content.push(cityStateZipText);
                        let phoneText = {
                          text: [
                            {
                              text: 'Phone: ' + prov.Phone.replace(/[^0-9]/g, '')
                                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                            }
                          ],
                          style: 'normal'
                        };
                        if (prov.WheelChairAccess === 1 || prov.AcceptingNewMember === 1 || prov.IsBoardCertified === 1 || prov.MedicaidID == 'Yes') {
                          phoneText.text.push('\t');
                        }
                        if (prov.WheelChairAccess === 1) {
                          phoneText.text.push({text: '', style: ['icon']});
                        }
                        if (prov.AcceptingNewMember === 1) {
                          phoneText.text.push({text: '', style: ['icon']});
                        }
                        if (prov.IsBoardCertified === 1) {
                          phoneText.text.push({text: '', style: ['icon']});
                        }
                        if (prov.MedicaidID == 'Yes') {
                          phoneText.text.push({text: 'M', fontSize: 12, bold: true});
                        }
                        dd.content.push(phoneText);
                      } else {
                        if (prov.WheelChairAccess === 1 || prov.AcceptingNewMember === 1 || prov.IsBoardCertified === 1 || prov.MedicaidID == 'Yes') {
                          cityStateZipText.text.push('\t');
                        }
                        if (prov.WheelChairAccess === 1) {
                          cityStateZipText.text.push({text: '', style: ['icon']});
                        }
                        if (prov.AcceptingNewMember === 1) {
                          cityStateZipText.text.push({text: '', style: ['icon']});
                        }
                        if (prov.IsBoardCertified === 1) {
                          cityStateZipText.text.push({text: '', style: ['icon']});
                        }
                        if (prov.MedicaidID == 'Yes') {
                          cityStateZipText.text.push({text: 'M', fontSize: 12, bold: true});
                        }
                        dd.content.push(cityStateZipText);
                      }

                      if(prov.PrimaryLanguageName) {
                        let language = {
                          "text": (prov.PrimaryLanguageName + (prov.SecondaryLanguageName ? ', ' + prov.SecondaryLanguageName : '') + (prov.OtherLanguageName ? ', ' + prov.OtherLanguageName : '')),
                          style: 'normal'
                        };
                        dd.content.push(language);
                      }
                      dd.content.push('\n');
                    }
                  }else{
                    if (prov.County === county.county && prov.State === st.state && prov.DirectoryCategory == sp) {
                      let nameText = {
                        text: prov.HospitalName,
                        style: 'normal'
                      };
                      dd.content.push(nameText);
                      let streetText = {
                        text: prov.Street1 + (prov.Street2 ? ', ' + prov.Street2 : ''),
                        style: 'normal'
                      };
                      dd.content.push(streetText);
                      let cityStateZipText = {
                        text: [{text: prov.City + (prov.State ? ', ' + prov.State : '') + (prov.Zip ? ', ' + prov.Zip : '') + (prov.distance ? ', ' + prov.distance : '')}],
                        style: 'normal'
                      };
                      if (prov.Phone) {
                        dd.content.push(cityStateZipText);
                        let phoneText = {
                          text: [
                            {
                              text: 'Phone: ' + prov.Phone.replace(/[^0-9]/g, '')
                                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                            }
                          ],
                          style: 'normal'
                        };
                        if (prov.WheelChairAccess === 1 ) {
                          phoneText.text.push('\t');
                          phoneText.text.push({text: '', style: ['icon']});
                        }
                        dd.content.push(phoneText);
                      } else {
                        if (prov.WheelChairAccess === 1 ) {
                          cityStateZipText.text.push('\t');
                          cityStateZipText.text.push({text: '', style: ['icon']});
                        }
                        dd.content.push(cityStateZipText);
                      }
                      let acceptingNewMemText = {text: 'Accepting New Patient: '+(prov.AcceptingNewMember === 1?'Yes':'No')+'\n' , style:'normal'};
                      dd.content.push(acceptingNewMemText);
                      if( prov.PrimarySpecialtyName && prov.PrimarySpecialtyName.trim().toUpperCase() === 'PHARMACY'){
                        if(prov.PrimaryVendorCodeName){
                          let vendorTypeText = {text: 'Type: '+ prov.PrimaryVendorCodeName +'\n' , style:'normal'};
                          dd.content.push(vendorTypeText);
                        }
                        if(prov.PCPContract){
                          let preferedText = {text: 'Preferred: '+ (prov.PCPContract.trim().toUpperCase() === 'Y'?'Yes':'No') +'\n' , style:'normal'};
                          dd.content.push(preferedText);
                        }
                      }
                      dd.content.push('\n');
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    ,
    searchLang: function (searchVal) {
      var tmpLang = [];
      if (searchVal) {
        this.orgLanguage.forEach(element => {
          var elementLowercase = element.text.toLowerCase();
          var searchValLowercase = searchVal.toLowerCase();
          if (elementLowercase.includes(searchValLowercase)) {
            tmpLang.push(element);
          }
        });
        this.languageFilterProv = tmpLang;
      } else {
        this.languageFilterProv = this.orgLanguages;
      }
    },
    searchSpec: function (searchVal, type) {
      var tmpSpec = [];
      if (searchVal) {
        if (type === 'prov') {
          this.orgSpecProv.forEach(element => {
            var elementLowercase = element.text.toLowerCase();
            var searchValLowercase = searchVal.toLowerCase();
            if (elementLowercase.includes(searchValLowercase)) {
              tmpSpec.push(element);
            }
          });
          this.specialtyFilterProv = tmpSpec;
        }
        if (type === 'hosp') {
          this.orgSpecHosp.forEach(element => {
            var elementLowercase = element.text.toLowerCase();
            var searchValLowercase = searchVal.toLowerCase();
            if (elementLowercase.includes(searchValLowercase)) {
              tmpSpec.push(element);
            }
          });
          this.specialtyFilterHosp = tmpSpec;
        }
      } else {
        if (type === 'prov') {
          this.specialtyFilterProv = this.orgSpecProv;
        }
        if (type === 'hosp') {
          this.specialtyFilterHosp = this.orgSpecHosp;
        }
      }
    },
    searchIPA: function (searchVal, type) {
      var tmpSpec = [];
      if (searchVal) {
        this.orgFacilityTypes.forEach(element => {
          var elementLowercase = element.text.toLowerCase();
          var searchValLowercase = searchVal.toLowerCase();
          if (elementLowercase.includes(searchValLowercase)) {
            tmpSpec.push(element);
          }
        });
        if (type === 'hosp') {
          this.facilityTypeFilterHosp = tmpSpec;
        }
      } else {
        if (type === 'hosp') {
          this.facilityTypeFilterHosp = JSON.parse(JSON.stringify(this.orgFacilityTypes));
        }
      }
    },
    searchState: function (searchVal, type) {
      var tmpSpec = [];
      if (searchVal) {
        this.orgStates.forEach(element => {
          var elementLowercase = element.StateName ? element.StateName.toLowerCase() : "";
          var searchValLowercase = searchVal.toLowerCase();
          if (elementLowercase.includes(searchValLowercase)) {
            tmpSpec.push(element);
          }
        });
        if (type === 'prov') {
          this.stateFilterProv = tmpSpec;
        }
        if (type === 'hosp') {
          this.stateFilterHosp = tmpSpec;
        }
      } else {
        if (type === 'prov') {
          this.stateFilterProv = JSON.parse(JSON.stringify(this.orgStates));
        }
        if (type === 'hosp') {
          this.stateFilterHosp = JSON.parse(JSON.stringify(this.orgStates));
        }
      }
    },
    async setDirectoryFrontMatter(frmData){
      //console.log("frmdata-------------", JSON.stringify(frmData))
      if(process.env.VUE_APP_CLIENT && process.env.VUE_APP_CLIENT.toUpperCase() === 'CSH'){
        let repCnt = 0;
        await this.provReportList.forEach((i)=>{
          let states = (i.value.ReportParams && JSON.parse(i.value.ReportParams).state) ?  JSON.parse(i.value.ReportParams).state:[];
          if (JSON.stringify(states)==JSON.stringify(frmData.state)) {
            // console.log(i);
            repCnt++;
            this.selectedReport = i.value;
          }
        });
        if(repCnt === 0) {
          this.selectedReport ={};
        }
      }
    },
    async checkForReport(frmData){

      if(frmData.state.length === 0 && !!frmData.county && frmData.county.length > 0){
        this.selectedReport = {};
        this.orgCounties.forEach((i)=>{
          frmData.county.forEach((j) =>{
            if(i.County.toUpperCase() === j.toUpperCase()){
              let statesList = JSON.parse(i.States)
              statesList.forEach((k)=>{
                frmData.state.push(k);
              })
            }
          })
        });
      }else if(frmData.state.length === 0 && !!frmData.zipCode){
        this.selectedReport = {};
        let stateForZip = await ProviderSearchService.getStateForZipCode(frmData.zipCode);
        if(stateForZip.length > 0){
          frmData.state.push(stateForZip[0].StateAbbr);
        }
      }
      this.disableHospCounty = !(this.form.hospData.state.length>0);
      this.disableProvCounty = !(this.form.provData.state.length>0);
      await this.setDirectoryFrontMatter(frmData);
    },
    async setCounty (e,type){

      if(type=='prov'){

        if(this.form.provData.county.length>0){
          let stateCountyList = [];
          await this.form.provData.county.forEach((each)=>{
            let stateList = [];
            let getCounties = this.orgCounties.filter(function (item) {
              return item.County == each;
            });
            if(getCounties.length>0){
              let curStateList = getCounties[0].States ? JSON.parse(getCounties[0].States) : [];
              let tempObj = {};
              tempObj.County = each;
              stateList = [].concat(stateList, curStateList);
              tempObj.stateList = stateList;
              stateCountyList.push(tempObj);
            }
          });
          await this.form.provData.county.forEach((each,index)=>{
            let eachStates = stateCountyList.filter(function (item) {
              return item.County == each;
            });

            let stateArr = eachStates.length>0 ? eachStates[0].stateList : [];
            stateArr.forEach(stArr=>{
              if(!this.form.provData.state.includes(stArr)){
                this.form.provData.county.splice(index, 1);
              }
            })
          });

        }
      }
      if(type=='hosp'){
        if(this.form.hospData.county.length>0){
          let stateCountyList = [];
          await this.form.hospData.county.forEach((each)=>{
            let stateList = [];
            let getCounties = this.orgCounties.filter(function (item) {
              return item.County == each;
            });
            if(getCounties.length>0){
              let curStateList = getCounties[0].States ? JSON.parse(getCounties[0].States) : [];
              let tempObj = {};
              tempObj.County = each;
              stateList = [].concat(stateList, curStateList);
              tempObj.stateList = stateList;
              stateCountyList.push(tempObj);
            }
          });
          await this.form.hospData.county.forEach((each,index)=>{
            let eachStates = stateCountyList.filter(function (item) {
              return item.County == each;
            });

            let stateArr = eachStates.length>0 ? eachStates[0].stateList : [];
            stateArr.forEach(stArr=>{
              if(!this.form.hospData.state.includes(stArr)){
                this.form.hospData.county.splice(index, 1);
              }
            })
          });

        }
      }
    },
    decreaseFontSize: function () {
      if (this.fontSize >= 12) {
        this.fontSize -= 1;
      }
      if (this.largeIconFontSize >= 19) {
        this.largeIconFontSize -= 1;
      }
      if (this.fontSizeSelect >= 12) {
        this.fontSizeSelect -= 0.5;
      }
      if (this.headerFontSize >= 15) {
        this.headerFontSize -= 1;
      }
    },
    increaseFontSize: function () {
      if (this.fontSize <= 17) {
        this.fontSize += 1;
      }
      if (this.largeIconFontSize <= 26) {
        this.largeIconFontSize += 1;
      }
      if (this.fontSizeSelect <= 13) {
        this.fontSizeSelect += 0.5;
      }
      if (this.headerFontSize <= 21) {
        this.headerFontSize += 1;
      }
    }
  },
  computed: {
    cusFontSize() {
      return {
        "font-size": this.fontSize + 'pt !important'
      };
    },
    largeFontSize() {
      return {
        "font-size": this.largeIconFontSize + 'pt !important'
      };
    },
    customCard() {
      if (this.modalPopup) {
        return {
          "cursor": "pointer"
        };
      } else {
        return {};
      }
    },
    cusHeaderFontSize() {
      return {
        "font-size": this.headerFontSize + 'pt !important'
      };
    },
    cusFontSizeSelect() {
      return {
        "font-size": this.fontSizeSelect + 'pt !important'
      };
    }

  }
};
</script>


<style scoped>
input[type="text"] {
  height: 30px;
}

.provrow:hover {
  background-color: #f1f6f6;
}

.card-body {
  padding: 0.55rem !important;
}

.anchor {
  border: 1px solid transparent;
  font-size: 14px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #25a7ce;
  border-color: #25a7ce;
}
.anchor_grey {
  border: 1px solid transparent;
  font-size: 14px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #858788;
  border-color: #858788;
}

.arrowDownIcon::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.28em solid transparent;
  border-bottom: 0;
  border-left: 0.28em solid transparent;
}

.anchor:hover {
  color: #fff;
  background-color: #248cab;
  border-color: #268cab;
  cursor: pointer;
}
.anchor_grey:hover {
  color: #fff;
  background-color: #bbc0c1;
  border-color: #918d8d;
  cursor: pointer;
}

.menu {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: #212529;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  list-style: none;
  margin: 0.125rem 0 0;
  padding: 0.5rem 0.5rem;
  position: absolute;
  text-align: left;
  width: 94%;
  z-index: 1;
  margin-top: 0px !important;
}

.btn-info.disabled, .btn-info:disabled {
  cursor: default;
}

.btn-secondary.disabled, .btn-secondary:disabled {
  cursor: default;
}

span {
  font-weight: bold;
  color: #717573;
  /*font-size: 14px;*/
}

.textDesc {
  font-weight: normal;
  color: #2c3e50;
}

.selTags {
  color: #717573;
  background-color: #fff;
  border: #fff;
  border-right: 1px solid #717573;
  padding-right: 3px !important;
  border-radius: 0;
}

.closeTags {
  font-size: 14px;
}

.filterText {
  color: #25a7ce;
}

sub,
sup {
  font-size: 14px;
  margin-right: 2px;
}

sup:hover {
  color: red !important;
}

.zipBoxSm {
  display: none;
}

.customLabel {
  font-size: 14px;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

::-webkit-input-placeholder {
  color: #dde2e7;
  font-size: var(--font-size);
}

::-moz-placeholder {
  color: #dde2e7;
  font-size: 13px;
}

:-ms-input-placeholder {
  color: #dde2e7;
  font-size: 13px;
}

::placeholder {
  color: #dde2e7;
  font-size: 13px;
}

.selectCust1 {
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.05rem center/8px 10px !important;
  width: 60px !important;
  padding-left: 10px !important;
}

.spinner {
  text-align: -webkit-center;
}

.hourBox {
  text-align: right;
  min-width: 25pt;
}

.customTitle {
  color: #5A5C5E;
  font-weight: 600;
  font-size: 20pt;
  margin: 0;
  border-left: 2px solid #ccc;
  padding-left: 10px;
}

.imgLogo {
  float: left;
  height: 60px;
}

.zipCodeInput {
  width: 145px !important;
  float: left;
}

.zipMilesSelect {
  width: 100px !important;
  float: left;
}

.card {
  border-radius: 20px !important;
}

@media screen and (min-width: 1000px) {
  .custPadding {
    padding: 0px !important;
  }
}

@media screen and (min-width: 1600px) {
  .custPadding {
    padding: 0px !important;
  }
}

@media screen and (min-width: 1900px) {
  .custPadding {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}

@media screen and (max-width: 1300px) {
  .custFontHeader {
    font-size: 20px !important;
    margin-bottom: 5px;
  }

  .card-body {
    font-size: 12px;
  }

  span {
    font-size: 12px;
  }
}

@media screen and (max-width: 1024px) {
  .custom-checkbox {
    display: inline-block;
    margin-left: 5px;
  }

  .hiddenSm {
    display: none
  }

  .hourBox {
    /*padding:0px 2px 0px 0px !important;*/
  }

}

@media screen and (max-width: 908px) {
  .zipMilesSelect {
    margin-left: 0px !important;
    margin-top: 5px !important;
    clear: both;
  }

  .zipBoxSm {
    display: block;
  }

}

@media screen and (max-width: 767px) {
  .hiddenXs {
    display: none;
  }

  .hourBox {
    text-align: left;
    /*margin-left: 15px !important;*/
    padding-left: 20px !important;
  }
}

@media screen and (max-width: 575px) {
  .zipMilesSelect {
    width: 40% !important;
    margin-top: 0px !important;
    margin-left: 15px !important;
    clear: none;
  }

  .zipCodeInput {
    width: 45% !important;
  }

  .hourBox {
    text-align: left;
    /*margin-left: 15px !important;*/
    padding-left: 20px !important;
  }
}

/*@media only screen and (max-width: 768px) and (min-width: 520px)  {*/
/*  .hourBox{*/
/*    padding:0px 5px 0px 0px !important;*/
/*    padding-left: 15px !important;*/
/*  }*/
/*}*/
@media screen and (max-width: 520px) {
  .inner-box-right {
    border-right: none !important;
  }

  .hiddenXs {
    display: none;
  }

  .hourBox {
    text-align: left;
  }

  .imgLogo {
    float: none !important;
  }

  .selTags {
    border-right: 0px !important;
  }

  .tagBox {
    padding: 0px !important;
  }

  .customTitle {
    border: none !important;
  }

  .titleBx {
    float: none !important;
    padding-top: 10px !important;
  }

  .selectCust1 {
    width: 40px !important;
    padding-left: 6px !important;
    padding-right: 1px !important;
  }
}
</style>
